import { Glyph } from '@/components/svgs/Glyph'
import { colors } from '@/constants/colors'
import type { ReferCard } from '@/features/home/homeTiles'
import { formatCents } from '@/lib/money'
import { Pressable } from '@/ui/core/pressable'
import { Text } from '@/ui/core/typography'
import { useState } from 'react'
import { View } from 'react-native'
import { ReferSheet } from './ReferSheet'

/** Referral as a flood row, for the days the grid is full of to-dos. Always on. */
export const ReferRow = ({ refer }: { refer: ReferCard }) => {
	const [isOpen, setIsOpen] = useState(false)
	const amount =
		refer.state === 'ready' && refer.discountInCents !== undefined
			? formatCents(refer.discountInCents)
			: '$25'
	return (
		<>
			<Pressable
				onPress={() => setIsOpen(true)}
				accessibilityRole="button"
				accessibilityLabel={`Give ${amount}, Get ${amount}. Refer a friend`}
				className="min-h-[64px] flex-row items-center rounded-note bg-white px-4 py-3"
				style={{ gap: 12 }}
			>
				<View className="h-10 w-10 items-center justify-center rounded-full bg-ground">
					<Glyph name="heart" size={20} color={colors.ink} />
				</View>
				<Text size="body0" weight="bold" className="flex-1">
					Give {amount}, Get {amount}
				</Text>
				<Glyph name="chevron" size={14} color={colors.ink} />
			</Pressable>
			{/* The row owns its sheet, as the tiles above it own theirs. */}
			<ReferSheet open={isOpen} onClose={() => setIsOpen(false)} />
		</>
	)
}
